<script setup>
import { ref } from "vue";
import YTCheckTagMultiple from "@/components/YTCheckTag/index.vue";


const props = defineProps({
  // 不传值默认150px;
  width: {
    type: Number,
    default: 0
  },
  // 展示的标签列表
  tagList: {
    required: true,
    type: Array,
    default: []
  },
  // 是否有下一页
  hasNextPage: {
    type: Boolean,
    default: false
  },
  // 已选择的标签数量
  selectedCount: {
    required: true,
    type: Number,
    default: 0
  },
  // 展示标签组的label
  tagGroupLabelKey: {
    type: String,
    default: 'tagGroupName'
  },
  // 展示标签组的key
  tagValueKey: {
    type: String,
    default: 'tagGroupId'
  },
  // 是否展示标签组
  isShowGroup: {
    type: Boolean,
    default: false
  },
  // 可选数量
  limit: {
    type: Number,
    default: 2
  }
})

const emit = defineEmits(['change', 'pageTurning'])

// 弹出框状态
const visible = ref(false);
// 处理触发器触发
const toggle = () => {
  visible.value = !visible.value;
}
// 处理弹窗关闭
const close = () => {
  visible.value = false;
}

// 处理活动标签弹窗滚动触底
const handleScroll = (e) => {
  const el = e.target
  if (el.scrollHeight - el.scrollTop <= el.clientHeight + 10) {
    // 滚动到底部了，发起事件告诉父组件
    emit('pageTurning')
  }
}
// 处理活动标签改变（触发事件，给予父组件处理）
const handleActivityTagChange = (list) => {
  emit('tagChange', list)
}
// 标签选择组件锚点
const YTCheckTagMultipleRef = ref()
// 处理标签选择组件反显
const handleYTCheckTagMultipleReview = (list) => {
  YTCheckTagMultipleRef.value.handleReview(list)
}
// 处理标签选择组件删除标签
const handleYTCheckTagMultipleRemove = (tagId) => {
  YTCheckTagMultipleRef.value.handleRemove(tagId)
}
// 处理标签选择组件置空选择项
const handleYTCheckTagMultipleReset = (list) => {
  YTCheckTagMultipleRef.value.handleReset(list)
}

defineExpose({
  handleYTCheckTagMultipleReview,
  handleYTCheckTagMultipleRemove,
  handleYTCheckTagMultipleReset
})
</script>

<template>
  <div>
    <!-- 使用 el-popover，并把 trigger slot 渲染到 reference 插槽 -->
    <el-popover
        v-model:visible="visible"
        placement="bottom-start"
        :offset="6"
        :show-arrow="false"
        :popper-style="{
          width: props.width ? props.width + 'px' : 'auto',
          minHeight: '105px',
          maxHeight: '245px',
          boxShadow: '0px 1px 6px 0px rgba(25,24,27,0.22)',
          borderRadius: '16px',
          overflow: 'hide'
        }"
        trigger="click"
        :teleported="false"
        transition="el-zoom-in-top"
        :hide-after="0"
    >
      <!-- reference 插槽 — 放触发器 -->
      <template #reference>
        <!-- 我们给外层一个容器，slot 会渲染用户传入的 trigger -->
        <div
            ref="triggerEl"
            class="my-dropdown-trigger-wrapper"
            @click.stop="toggle"
            data-dropdown-trigger
        >
          <slot name="trigger" :toggle="toggle" :visible="visible" />
        </div>
      </template>

      <!-- 弹窗内容 -->
      <div @click.stop>
        <div class="activity_tag_box" @scroll.stop>
<!--          <div class="activity_tag_box" @scroll.stop="handleScroll">-->
          <YTCheckTagMultiple
              ref="YTCheckTagMultipleRef"
              :limit="props.limit"
              :options="tagList"
              @change="handleActivityTagChange"
              label-key="tagName"
              value-key="tagId"
              :selectedCount="props.selectedCount"
          >
          </YTCheckTagMultiple>
<!--          <div class="activity_tag_page_tips">{{hasNextPage ? '加载中...' : '暂无更多信息'}}</div>-->
        </div>
      </div>
    </el-popover>
  </div>
</template>

<style lang="scss" scoped>
.my-dropdown-trigger-wrapper {
  display: flex;
  justify-items: center;
  align-items: center;
}
.activity_tag_box {
  width: 100%;
  max-height: 221px;
  overflow: auto;
  .activity_tag_page_tips {
    font-size: 13px;
    color: #a8abb2;
    text-align: center;
  }
}
</style>
